import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import EveThemeProvider from '@ashn/eve-themes-react/EveThemeProvider';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import PropTypes from 'prop-types';
import { useState } from 'react';
import SideNavigation from '../SideNavigation/SideNavigation';
import useIsMobile from '../../../hooks/useIsMobile';
import useSessionContext from '../../../data/queryHooks/useSessionContext';
import ResourceSelector from '../ResourceSelector';

const PageLayout = ({
	pageTitle,
	navItems = undefined,
	children = undefined,
	renderBackButton = false,
}) => {
	const isMobile = useIsMobile();
	const navigate = useNavigate();
	const sessionContext = useSessionContext();
	const location = useLocation();
	const [specialtyAndDistinction, setSpecialtyAndDistinction] =
		useState(null);
	const [region, setRegion] = useState(null);
	return (
		<EveThemeProvider themeKey='internal' themeMode='light'>
			<Container component='main' role='main'>
				<header>
					{renderBackButton && (
						<Button
							onClick={() => navigate(-1)}
							variant='text'
							sx={{ px: 0, pt: 3 }}
						>
							<KeyboardArrowLeftIcon sx={{ ml: -1 }} /> Back
						</Button>
					)}
					<Typography
						variant={
							pageTitle === 'Manage Sub Accounts' ? 'h5' : 'h4'
						}
						component='h1'
						mb={2}
						pt={3}
					>
						{pageTitle}
					</Typography>
					<Divider sx={{ mb: 4 }} />
				</header>
				<Box sx={{ display: 'flex', flexDirection: 'row', gap: 3 }}>
					{!isMobile && navItems && (
						<Box
							component='nav'
							role='navigation'
							sx={{ width: '250px', flexShrink: 0 }}
						>
							{sessionContext.isTest &&
								location.pathname.indexOf('/resources/') ===
									0 && (
									<ResourceSelector
										specialtyAndDistinction={
											specialtyAndDistinction
										}
										setSpecialtyAndDistinction={
											setSpecialtyAndDistinction
										}
										region={region}
										setRegion={setRegion}
									/>
								)}
							<SideNavigation pages={navItems} />
						</Box>
					)}
					<Box component='section' sx={{ flex: 1, minWidth: 0 }}>
						{children}
						<Outlet context={{ specialtyAndDistinction, region }} />
					</Box>
				</Box>
			</Container>
		</EveThemeProvider>
	);
};

export default PageLayout;

PageLayout.propTypes = {
	pageTitle: PropTypes.string.isRequired,
	navItems: PropTypes.array,
	children: PropTypes.node,
	renderBackButton: PropTypes.bool,
};
